function clone(object) {
  if (!object || typeof object !== 'object') {
    return object;
  }
  return JSON.parse(JSON.stringify(object));
}

export default class NotImplementedError extends Error {
  constructor(message, data) {
    super(`${message} is not implemented`);
    this.data = data ? clone(data) : undefined;
  }
}
